module.exports = __webpack_public_path__ + "img/total_withdrawal_limit.446f4b26.png";